import React from 'react';
import { COLORS } from '../../styles/variables';

interface PhoneIconProps {
  color?: string;
}

const PhoneIcon: React.FC<PhoneIconProps> = ({ color = COLORS.black }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5,23.3 L21.5,19.5 C21.7,19.3 21.7,18.7 21.5,18.5 L18.5,15.5 C18.3,15.3 17.7,15.3 17.5,15.5 L16,16.8 C16,16.8 15.3,17.9 11.1,13.7 L10.6,13.2 C6.3,8.9 7.5,8.5 7.5,8.5 L8.5,7.5 C8.7,7.3 8.7,6.7 8.5,6.5 L5.5,3.5 C5.3,3.3 4.7,3.3 4.5,3.5 L0.7,7.5 C0.7,7.5 6.5,17.1 17.5,23.3 Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default PhoneIcon;
